<template>
    <div class="right-content">
        <div class="right-content-title"></div>
        <div class="right-content-body">
            <div class="title">
                <!--                    <img src="../../assets/image/artist-artist-text/our-earth.png" height="100%" />-->
                我们的地球
            </div>
            <div class="content">
                <p class="bold">质量</p>
                <div class="content-text-with-imgs">
                    <div class="left-text">
                        <p class="indent">卡文迪许认为地球的质量约为6×10^24千克，地球的赤道半径ra=6378137m≈6.378×10^6m，极半径rb=6356752m≈6.357×10^6m，扁率e=1/298.257,忽略地球非球形对称，平均半径r=6.371×10^6m。在赤道某海平面处重力加速度的值ga=9.780m/s^2,在北极某海平面处的重力加速度的值gb=9.832m/s^2，全球通用的重力加速度标准值g=9.807m/s^2，地球自转周期为23小时56分4秒（恒星日），即T=8.616×10^4s。</p>
                    </div>
                    <div class="right-text-img">
                        <div class="right-image">
                            <img src="../../assets/images/earth.jpg" />
                        </div>
                        <div class="right-text">
                            地球
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>

                <p class="bold center">温度</p>
                <p class="indent">地球上最高温度发生在闪电中。一次闪电能释放地核的温度大约是4700℃，比太阳光球表面温度（6000℃）略低。地球上最高温度发生在闪电中。一次闪电能释放100亿焦耳的能量，达到30000℃，这温度是太阳表面温度的5倍，但比太阳核心的温度（1400万摄氏度）低多了。地球上最冷的地方在哪里？北半球的“冷极”在西伯利亚东部的奥伊米亚康，1961年1月的最低温度是–71℃。南半球的“冷极”在南极大陆，1960年8月24日气温为–88.3℃。</p>
                <p class="bold center">形状</p>
                <p class="indent">科学家经过长期的精密测量，发现地球并不是一个规则球体，而是一个两极稍扁、赤道略鼓的不规则球体。地球的赤道半径约长6378.137Km ，这点差别与地球的平均半径相比，十分微小，从宇宙空间看地球，仍可将它视为一个规则球体。</p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "IntroduceView"
    }
</script>

<style lang="scss" scoped>
    .split-style {
        text-align: center;
        .split-style-span1 {
            width: 10px;
            height: 2px;
            margin-left: 5px;
            display: inline-block;
            background: #000;
        }
        .split-style-span {
            width: 15px;
            height: 4px;
            margin-left: 5px;
            display: inline-block;
            background: #000;
            box-shadow: 5px 6px #5A656E;
        }
    }
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .title {
            text-align: center;
        }
        .bold {
            font-weight: bolder;
        }
        .indent {
            text-indent: 26px;
        }
        .center {
            text-align: center;
        }
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            -ms-overflow-style: none;
            overflow: -moz-scrollbars-none;

            &::-webkit-scrollbar {
                width: 0 !important
            }
            .content-text-with-imgs {
                .left-text {
                    float: left;
                    width: 60%;
                }
                .right-text-img {
                    text-align: center;
                    float: right;
                    width: 40%;
                }
                .right-text {
                    -webkit-text-stroke: 0.03em #000000;
                    -webkit-text-fill-color: transparent;
                    font-size: 40px;
                    text-shadow: 3px 3px 1px #b2b2b2;
                    font-family: SimSun;
                    font-style: italic;
                }
            }
        }
    }
</style>